import { UserTabsVariants } from 'src/models/IUser';

export type UserRole =
  | 'SUPER_ADMIN'
  | 'ANALYTIC'
  | 'MAIN_CONTENT_MANAGER'
  | 'CONTENT_MANAGER'
  | 'MERCHANT_MANAGER'
  | 'CALL_CENTER_OPERATOR'
  | 'CALL_CENTER_MASTER';

export const role: Record<UserRole, string> = {
  SUPER_ADMIN: 'Супер администратор',
  ANALYTIC: 'Аналитик',
  MAIN_CONTENT_MANAGER: 'Старший контент менеджер',
  CONTENT_MANAGER: 'Контент менеджер',
  MERCHANT_MANAGER: 'Менеджер по работе с мерчантами',
  CALL_CENTER_OPERATOR: 'Оператор колл центра',
  CALL_CENTER_MASTER: 'Старший оператор колл центра',
};

export const newRoles = Object.entries(role).map(([key, value]) => ({ code: key, value }));

export const status = {
  ACTIVE: 'Активен',
  BLOCKED: 'Заблокирован',
};

export const newStatus = [
  {
    code: 'ACTIVE',
    value: 'Активен',
  },
  {
    code: 'BLOCKED',
    value: 'Заблокирован',
  },
];

export const blockAdminReasons = [
  {
    code: 'FORMAL',
    value: 'Формальность',
  },
  {
    code: 'DIFFERENT',
    value: 'Другое',
  },
];

export const typeOrganization = [
  {
    code: 'OOO',
    value: 'ООО',
  },
  {
    code: 'IP',
    value: 'ИП',
  },
  {
    code: 'UP',
    value: 'УП',
  },
  {
    code: 'ZAO',
    value: 'ЗАО',
  },
  {
    code: 'OAO',
    value: 'OAO',
  },
];

export const russianRegions = [
  {
    code: 'RU-MOW',
    value: 'г. Москва',
  },
  {
    code: 'RU-MOS',
    value: 'Московская обл.',
  },
];

export const typeAgent = [
  {
    code: 'PRODUCTS',
    value: 'Товары',
  },
  {
    code: 'SERVICES',
    value: 'Услуги',
  },
  {
    code: 'SERVICES_AND_PRODUCTS',
    value: 'Товары и услуги',
  },
];

export const goodsCategory = [
  {
    code: 'ALL',
    value: 'mock',
  },
  {
    code: 'NEW',
    value: 'mock-1',
  },
];

export const taxSystem = [
  {
    code: 'USN',
    value: 'УСН',
  },
  {
    code: 'ENVD',
    value: 'ЕНВД',
  },
];

export const merchEmployeeRoles = [
  {
    code: 'OWNER',
    value: 'Владелец',
  },
  {
    code: 'ADMIN',
    value: 'Администратор',
  },
  {
    code: 'PRODUCT_MANAGER',
    value: 'Менеджер по товарам',
  },
  {
    code: 'FINANCIAL_MANAGER',
    value: 'Финансовый менеджер',
  },
  {
    code: 'ANALYTIC',
    value: 'Менеджер по продвижению',
  },
];

export const userTabsItems = [
  {
    value: 'Учетная запись',
    code: UserTabsVariants.profile,
  },
  {
    value: 'Список заказов',
    code: UserTabsVariants.orders,
  },
  {
    value: 'Отложенные товары',
    code: UserTabsVariants.favourites,
  },
  {
    value: 'Возвраты',
    code: UserTabsVariants.returns,
  },
];
